const PINE_KEYWORDS = new Set([
  "alertcondition",
  "and",
  "bool",
  "color",
  "false",
  "float",
  "if",
  "input",
  "int",
  "math",
  "na",
  "not",
  "or",
  "plot",
  "plotshape",
  "shape",
  "strategy",
  "ta",
  "true",
  "var",
]);

export function PineCodePreview({ code }: { code: string }) {
  return (
    <pre className="max-h-[680px] overflow-auto rounded-[var(--radius)] border border-[var(--border)] bg-[#07090d] p-4 text-[12.5px] leading-6 text-[var(--fg)]">
      {code.split("\n").map((line, i) => (
        <span key={`${i}-${line}`} className="block min-w-max">
          <span className="mr-4 inline-block w-8 select-none text-right text-[var(--fg-fainter)]">
            {i + 1}
          </span>
          <CodeLine line={line} />
        </span>
      ))}
    </pre>
  );
}

function CodeLine({ line }: { line: string }) {
  const commentIdx = line.indexOf("//");
  const code = commentIdx >= 0 ? line.slice(0, commentIdx) : line;
  const comment = commentIdx >= 0 ? line.slice(commentIdx) : "";
  const parts = code.split(/("[^"]*"|\b[A-Za-z_][A-Za-z0-9_]*\b|\d+(?:\.\d+)?)/g);
  return (
    <>
      {parts.map((part, idx) => {
        if (!part) return null;
        if (part.startsWith('"') && part.endsWith('"')) {
          return (
            <span key={`${idx}-${part}`} className="text-[#d7ff7a]">
              {part}
            </span>
          );
        }
        if (/^\d/.test(part)) {
          return (
            <span key={`${idx}-${part}`} className="text-[#8fd3ff]">
              {part}
            </span>
          );
        }
        if (PINE_KEYWORDS.has(part)) {
          return (
            <span key={`${idx}-${part}`} className="text-[#f0a6ff]">
              {part}
            </span>
          );
        }
        return <span key={`${idx}-${part}`}>{part}</span>;
      })}
      {comment ? <span className="text-[var(--fg-fainter)]">{comment}</span> : null}
    </>
  );
}
